import { Action } from '@ngrx/store';
import { PaymentMethods } from '../../models';

export enum PaymentMethodsActionTypes {
  READ_PAYMENT_METHODS = '[app-checkout/Checkout] Read payment methods',
  READ_PAYMENT_METHODS_SUCCESS = '[app-checkout/Checkout] Read payment methods Success',
  READ_PAYMENT_METHODS_FAILURE = '[app-checkout/Checkout] Read payment methods Failure',
}

export class ReadPaymentMethods implements Action {
  readonly type = PaymentMethodsActionTypes.READ_PAYMENT_METHODS;
  constructor(public payload?: string) {}
}

export class ReadPaymentMethodsSuccess implements Action {
  readonly type = PaymentMethodsActionTypes.READ_PAYMENT_METHODS_SUCCESS;
  constructor(public payload: PaymentMethods[]) {}
}

export class ReadPaymentMethodsFailure implements Action {
  readonly type = PaymentMethodsActionTypes.READ_PAYMENT_METHODS_FAILURE;
  constructor(public payload: any) {}
}

export type PaymentMethodsActions = ReadPaymentMethods | ReadPaymentMethodsSuccess | ReadPaymentMethodsFailure;
